import { useEffect, useState } from 'react';
import { AlertTriangle, Flame, TestTube2 } from 'lucide-react';

function EnvironmentBanner() {
  const [environment, setEnvironment] = useState(null);
  
  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_BASE_URL || '';
    
    // Determine environment based on API URL
    if (apiUrl.includes('galaxy.ecofy.co.in')) {
      // Production - don't show banner
      setEnvironment(null);
    } else if (apiUrl.includes('.dev.')) {
      setEnvironment({ name: 'DEVELOPMENT', color: 'bg-yellow-500', icon: TestTube2 });
    } else if (apiUrl.includes('.pp.')) {
      setEnvironment({ name: 'PRE-PRODUCTION', color: 'bg-orange-500', icon: Flame });
    } else if (apiUrl.includes('.test') || apiUrl.includes('localhost')) {
      setEnvironment({ name: 'TEST', color: 'bg-purple-500', icon: TestTube2 });
    } else if (apiUrl) {
      // Unknown non-prod environment
      setEnvironment({ name: 'NON-PRODUCTION', color: 'bg-gray-500', icon: AlertTriangle });
    }
  }, []);

  if (!environment) return null;

  const Icon = environment.icon;

  return (
    <div className={`${environment.color} text-white py-1 px-4 text-center text-xs font-semibold flex items-center justify-center gap-2 shadow-md z-50 sticky top-0`}>
      <Icon size={14} />
      <span>{environment.name} ENVIRONMENT</span>
    </div>
  );
}

export default EnvironmentBanner;
